module.exports = __webpack_public_path__ + "assets/TaskLockedOverlay.d898dc9caf11bc531aa8236862a4fc7a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svg/levels/TaskLockedOverlay.svg
// module id = 866
// module chunks = 0